import { Dispatch, SetStateAction, useState } from "react";
import { RegisterVisitaForm } from "../RegisterVisitaForm";
import { CurrentComponent } from "./DealInformation";
import { useCreateVisitMutation } from "../../../../api/visitasApi";
import { VisitaRegister } from "../../../../types/empresa";
import { getErrorMessage } from "../../../../utils/errorHelpers";

interface Props {
    dealId: number;
    fechaInicio?: string;
    fechaFinal?: string;
    tipoVisitaId: number;
    setCurrentComponent: Dispatch<SetStateAction<CurrentComponent>>
}

export function AddVisitFromDealInformation({ dealId, setCurrentComponent, tipoVisitaId, fechaInicio, fechaFinal }: Props) {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const [createVisit, { isLoading }] = useCreateVisitMutation();

    const handleOnAddVisit = async (data: VisitaRegister) => {
        try {
            setErrorMessage(null);

            data.horaInicio = data.horaInicio != undefined 
                ? `${data.horaInicio}:00`
                : data.horaInicio;

            data.horaFin = data.horaFin != undefined 
                ? `${data.horaFin}:00`
                : data.horaFin;

            const request = {
                dealId,
                visita: {
                    fecha: data.fecha,
                    horaInicio: data.horaInicio,
                    horaFin: data.horaFin,
                    tipoVisita: tipoVisitaId,
                    turno: data.turno,
                    vendedoresAsignados: data.vendedoresAsignados, 
                }
            };

            await createVisit(request).unwrap();

            setCurrentComponent({ component: "Deal", visitaId: null });
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    }

    return (
        <RegisterVisitaForm
            isLoading={isLoading}
            errorMessage={errorMessage}
            onAddVisit={handleOnAddVisit}
            onCancel={() => setCurrentComponent({ component: "Deal", visitaId: null })}/>
    );
}